import { render, staticRenderFns } from "./EbookDetail.vue?vue&type=template&id=01e30dd7&scoped=true"
import script from "./EbookDetail.vue?vue&type=script&lang=js"
export * from "./EbookDetail.vue?vue&type=script&lang=js"
import style0 from "./EbookDetail.vue?vue&type=style&index=0&id=01e30dd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e30dd7",
  null
  
)

export default component.exports